import { render, staticRenderFns } from "./reviewApplication.vue?vue&type=template&id=50a483b2"
import script from "./reviewApplication.vue?vue&type=script&lang=js"
export * from "./reviewApplication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports